import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/common/guards/auth/auth.guard';
import { CreateProjectComponent } from './create-project/create-project.component';
import { ManageProjectComponent } from './project-detail-info/manage-project/manage-project.component';
import { ProjectDetailInfoComponent } from './project-detail-info/project-detail-info.component';
import { ProjectsNavigationComponent } from './projects-navigation.component';
import { UserProjectsComponent } from './user-projects/user-projects.component';

const projectsRoutes: Routes = [
  {
    path: '',
    component: ProjectsNavigationComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'all', pathMatch: 'full' },
      { path: 'all', component: UserProjectsComponent },
      { path: 'create', component: CreateProjectComponent, pathMatch: 'full' },
      { path: 'view/:id', component: ProjectDetailInfoComponent },
      { path: 'manage/:id', component: ManageProjectComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(projectsRoutes)],
  exports: [RouterModule],
})
export class ProjectsRoutingModule {}
